import Flickity from "flickity";

export default () => {
    const gallery = document.querySelector("[data-gallery-carousel]");
    if (gallery) {
        if (gallery.childNodes.length > 1) {
            const flickity = new Flickity(gallery, {
                // options
                contain: true,
                prevNextButtons: true,
                pageDots: false,
                autoPlay: 5000,
                wrapAround: false,
            });
        }
    }
};
